import React from "react";
import "./App.css";
import "@/style/iconfont/iconfont.less";
import { routes } from "./router/index";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { ConfigProvider } from "@arco-design/web-react";
import { Helmet } from "react-helmet";
function App() {
  const router = createBrowserRouter(routes);
  return (
    <div className="App">
      <ConfigProvider getPopupContainer={(node) => node.parentElement}>
        <RouterProvider router={router}></RouterProvider>
      </ConfigProvider>
    </div>
  );
}

export default App;
